import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IntroVideo.css'; // Add your styles here
import CustomLinks from "../CustomLink/CustomLink";

const IntroVideo = ({ title, links = [], image = [] }) => {
  const [zoomClass, setZoomClass] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Track the current image index
  const [progress, setProgress] = useState(0); // State to track the loading progress

  useEffect(() => {
    if (image.length === 0) return; // Do nothing if image array is empty

    const interval = setInterval(() => {
      setZoomClass(false); // Reset zoom immediately
      setTimeout(() => {
        setZoomClass(true); // Apply zoom after the image resets
        setCurrentImageIndex((prevIndex) =>
          (prevIndex + 1) % image.length
        ); // Cycle through images
      }, 100); // Delay to ensure reset happens first
    }, 10000); // Change image every 10 seconds

    return () => clearInterval(interval);
  }, [image]);

  useEffect(() => {
    if (image.length === 0) return; // Do nothing if image array is empty

    let progressInterval;

    setProgress(0); // Reset progress when component mounts or updates
    progressInterval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) return 100;
        return prevProgress + 1; // Increase progress by 1% every 100ms
      });
    }, 100); // 100ms interval to reach 100% in 10 seconds

    return () => clearInterval(progressInterval);
  }, [currentImageIndex, image]);

  if (image.length === 0) {
    return <div>No images available</div>;
  }

  return (
    <div className="home-intro">
      <div
        className={`home-intro-background ${zoomClass ? 'zoom' : ''}`}
        style={{
          backgroundImage: `url(${image[currentImageIndex]})`,
        }}
      ></div>
      <div className="home-intro-content">
        <h1 className="home-intro-contentTitle">{title}</h1>
        <div className="home-intro-contentLinks">
          {links.map((link, index) => (
            <CustomLinks key={index} link={link.url} linktext={link.name} />
          ))}
        </div>

        {/* Progress bar */}
        <div className="progress-bar">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
    </div>
  );
};


export default IntroVideo;
